// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_1_myBtn__Mdy1O"};